import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0 0 0 5px;
  .detalhes-captacao-title {
    width: 100%;
    height: 24px;
    color: var(--Preto-Principal, #1c1d22);
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;

    margin-bottom: 8px;
  }

  .detalhes-captacao-subtitle {
    width: 100%;
    color: #000;

    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    margin-bottom: 16px;
  }

  .status-card-captacao {
    display: flex;
    align-items: center;
    color: #03989e;

    gap: 10px;
    margin-bottom: 8px;

    width: 100%;
    height: 26px;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px; /* 185.714% */
    letter-spacing: 0.2px;
  }

  .status-card-captacao-img {
    width: 16px;
    height: 16px;
    filter: ${Theme.icons.SEPTENARY};
    margin-bottom: 5px;
  }

  .status-card-container-cards {
    display: flex;
    width: 70%;
    flex-wrap: wrap;
    gap: 16px 20px;
    margin-left: 1px;
    padding-bottom: 32px;
  }
`
